import { render, staticRenderFns } from "./BannerDropdown.vue?vue&type=template&id=0273c774&"
import script from "./BannerDropdown.vue?vue&type=script&lang=js&"
export * from "./BannerDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports